import { Box, Skeleton, TableBody, TableCell, TableRow } from "@mui/material";
import { FC } from "react";
import { TableSkeletonProps } from "../../interfaceTypes";

export const JudgeAgainstSkeletonListing: FC<TableSkeletonProps> = ({ noOfRows }) => (
  <TableBody>
    {new Array(noOfRows).fill(0).map((_, index) => (
      <TableRow key={`${index}-skeleton`}>
        <TableCell>
          <Box maxWidth='250px'>
            <Skeleton variant="text" width={150} height={30} />
            <Skeleton variant="text" width={250} height={30} />
          </Box>
        </TableCell>

        <TableCell>
          <Skeleton variant="text" width={80} height={30} />
        </TableCell>

        <TableCell align="center">
          <Skeleton variant="text" width={80} height={30} sx={{ margin: 'auto' }} />
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
);